<template>
  <Result :title="title" :state="state" :message="message"/>
</template>

<script>
import * as R from 'ramda'
import axios from 'axios'
import Promise from 'bluebird'
import Result from '@/components/Results/ResultBase.vue'
import { STATE } from '@/constants.js'
export default {
  name: 'ResultOfNetwork',
  props: {
    connectData: {
      type: Object,
      required: true
    },
    connectionLimit: {
      type: Object,
      required: true
    }
  },
  components: {
    Result
  },
  data () {
    return {
      title: '回線速度',
      state: STATE.PROGRESS,
      message: '通信速度を測定しています...',
    }
  },
  methods: {
    async loadTsFile () {
      return axios.get(this.connectData.connectTo, {
        params: {
          c: new Date().getTime()
        },
        // 下記を書かなくても勝手にvideo/mp2tをつけて送る
        // headers: {
        //   'Content-Type': 'video/mp2t'
        // },
        // data: {}
      }) 
    }
  },
  async created () {

    const getSetting = (key, prop) => R.view(R.lensPath([key, prop]), this.connectionLimit)

    const startTime = performance.now() // 測定開始
    try {
      await Promise.mapSeries(R.times(R.identity, this.connectData.frequency), this.loadTsFile)
    } catch (error) {
      this.message = getSetting('unstable', 'msg')
      this.state = 2
      return
    }
    
    const endTime = performance.now() // 測定終了
    const averageSec = ((endTime - startTime) / this.connectData.frequency) / 1000
    const bit = this.connectData.fileSize * 8
    const bitPerSecond = bit / averageSec
    const kiloBitPerSeconds= bitPerSecond / 1024
    const roundedbps = Math.round(kiloBitPerSeconds)

    const createMessage = (status) => {
      return getSetting(status, 'msg') 
      + '(' + roundedbps.toLocaleString() + ' Kbps)' 
      + getSetting(status, 'msg2')
    }
    const switchLabel = R.cond([
      [R.gt(getSetting('disable', 'limit')), R.always(createMessage('disable'))],
      [R.gt(getSetting('low', 'limit')), R.always(createMessage('low'))],
      [R.gt(getSetting('mid', 'limit')), R.always(createMessage('mid'))],
      [R.gt(getSetting('high', 'limit')), R.always(createMessage('high'))],
      [R.T, R.always(createMessage('overspec'))]
    ])
    const switchStatus = R.cond([
      [R.gt(getSetting('low', 'limit')), R.always(STATE.ERROR)],
      [R.T, R.always(STATE.OK)]
    ])

    this.message = switchLabel(kiloBitPerSeconds)
    this.state = switchStatus(kiloBitPerSeconds)

  }
}
</script>

<style>

</style>
